import React, { ChangeEvent, ReactElement } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import Color from 'octa-front-sdk/dist/enums/Color';
import InputIconStyles from './styles';

import CustomInput from '../CustomInput';
import BtnIcon from '../BtnIcon';

interface IProps {
  name: string;
  value: string;
  placeholder: string;
  onChange: (params: ChangeEvent<HTMLInputElement>) => void;
  btnFunction: () => void;
  btnIcon: IconProp;
}

const InputIcon: React.FC<IProps> = (props): ReactElement => {
  const { name, value, placeholder, onChange, btnFunction, btnIcon } = props;
  return (
    <InputIconStyles.Container>
      <CustomInput
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
      <BtnIcon onClick={btnFunction} icon={btnIcon} color={Color.BlueGrey600} />
    </InputIconStyles.Container>
  );
};

export default InputIcon;
